import { ITranslateService } from '@dlw-int-mwi/eps-common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { logger } from '../../core/util/logger';

@Injectable({ providedIn: 'root' })
export class TranslationAdapterService implements ITranslateService {
  constructor(private translateService: TranslateService) {
  }

  translate(key: string, interpolateParams: object): string | undefined {
    const translatedDateField = this.translateDateFields(key);
    if (translatedDateField) {
      return translatedDateField;
    }
    const decoratedKey = decorateKey(key);
    const translation = this.translateService.instant(decoratedKey, interpolateParams);
    if (translation === decoratedKey && decoratedKey.indexOf(' ') < 0) { // if not translated and not a message
    //   return undefined;
      logger.log(`not translated: ${decoratedKey}`);
    }
    return translation;
  }

  translate$(key: string, interpolateParams: object): Observable<string | undefined> {
    const dateTranslation = this.translateDateFields(key);
    if (dateTranslation && !interpolateParams) {
      return of(dateTranslation);
    }
    const decoratedKey = decorateKey(key);
    const translationObservable = this.translateService.get(decoratedKey, interpolateParams).pipe(
      map(translation => {
        if (translation === decoratedKey && decoratedKey.indexOf(' ') < 0) { // if not translated and not a message
          logger.log(`not translated: ${decoratedKey}`);
        }
        return translation;
      })
    );
    return translationObservable;
  }

  private translateDateFields(key: string): string | undefined {
    switch (key) {
      case 'common.input.week.format':
        const week = this.translateService.instant('SHARED.WEEK');
        return `'${week}' W, kkkk`;
      case 'common.input.date.format':
        return 'dd/MM/yyyy';
    }
    return undefined;
  }
}

const decorateKey = (key: string) => {
  if (key?.startsWith('common')) {
    return `EPS-COMMON.${key}`;
  }
  return key;
}
